"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsSelector = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const options_list_1 = require("./options-list");
const settings_selector_styles_1 = require("./settings-selector.styles");
const localization_1 = require("../../../localization");
const SettingsSelector = ({ isLoading, options, selectedId, error, placeholder, selectedSectionTitle, listSectionTitle, emptyDataText, label, onSelect, className, hideSecondaryAction, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [menuAnchorEl, setMenuAnchorEl] = (0, react_1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const isOpen = !!menuAnchorEl;
    const handleListItemClick = (e) => {
        setMenuAnchorEl(e.currentTarget);
    };
    const { selectedOption, restOptions } = (0, react_1.useMemo)(() => options === null || options === void 0 ? void 0 : options.reduce((acc, item) => {
        var _a;
        if (item.id === selectedId) {
            acc.selectedOption = item;
            return acc;
        }
        acc.restOptions = ((_a = acc.restOptions) !== null && _a !== void 0 ? _a : []).concat(item);
        return acc;
    }, {}), [options, selectedId]);
    const handleMenuItemClick = (id) => {
        setMenuAnchorEl(null);
        onSelect(id);
    };
    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
        setSearchTerm('');
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.currentTarget.value);
    };
    const filteredOptions = (0, react_1.useMemo)(() => (searchTerm === ''
        ? restOptions
        : restOptions === null || restOptions === void 0 ? void 0 : restOptions.filter((option) => option.title.toLowerCase().includes(searchTerm.toLowerCase()))), [searchTerm, restOptions]);
    return (react_1.default.createElement(react_1.default.Fragment, null, label && (react_1.default.createElement(ui_components_1.Typography, { strong: true, variant: "overline", color: "textSecondary" }, label)), react_1.default.createElement(settings_selector_styles_1.StyledSettingsSelector, { className: className }, react_1.default.createElement(settings_selector_styles_1.StyledList, null, react_1.default.createElement(settings_selector_styles_1.StyledListItem, { disabled: isLoading, onClick: handleListItemClick }, react_1.default.createElement(material_1.ListItemText, { primary: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title, secondary: selectedOption ? '' : placeholder }), isLoading ? (react_1.default.createElement(material_1.CircularProgress, { size: "small" })) : (react_1.default.createElement(settings_selector_styles_1.StyledArrowIcon, { variant: "downArrow", "$menuOpen": !!menuAnchorEl, color: ui_components_1.baseColors.primaryBlueMed400 }))))), react_1.default.createElement(settings_selector_styles_1.StyledMenu, { keepMounted: true, anchorEl: menuAnchorEl, open: isOpen, onClose: handleCloseMenu, elevation: 0, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        } }, react_1.default.createElement(settings_selector_styles_1.StyledMenuContentWrapper, null, react_1.default.createElement(settings_selector_styles_1.StyledSearchInput, { onChange: handleSearchChange, value: searchTerm, placeholder: t({ key: 'SEARCH' }), startAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryBlueMed400, className: "search-icon" })) }), selectedId && !error && (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(options_list_1.OptionsList, { isSelected: true, title: selectedSectionTitle, options: selectedOption ? [selectedOption] : [] }), react_1.default.createElement(material_1.Divider, null))), react_1.default.createElement(options_list_1.OptionsList, { hideSecondaryAction: hideSecondaryAction, title: listSectionTitle, options: filteredOptions, onClick: handleMenuItemClick, noData: react_1.default.createElement(ui_components_1.Typography, { variant: "body2", color: "textSecondary" }, emptyDataText), errorMessage: error })))));
};
exports.SettingsSelector = SettingsSelector;
exports.default = exports.SettingsSelector;
